import { render, staticRenderFns } from "./HomeInfo.vue?vue&type=template&id=df537484&scoped=true"
import script from "./HomeInfo.vue?vue&type=script&lang=js"
export * from "./HomeInfo.vue?vue&type=script&lang=js"
import style0 from "./HomeInfo.vue?vue&type=style&index=0&id=df537484&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df537484",
  null
  
)

export default component.exports